import React from "react";
import PropTypes from "prop-types";
import { Input } from "antd";
import cx from "classnames";
import "styles/search-filter.css";
const Component = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    filterOverrideClassName
}) => {
    let input = null;
    // let ignoreBlur = false;
    return (
        <div
            className={cx("custom-filter-dropdown", filterOverrideClassName)}
            onFocus={e => e.stopPropagation()}
        >
            <Input
                ref={node => (input = node)}
                placeholder="Search name"
                value={selectedKeys[0]}
                onChange={e => {
                    e.stopPropagation();
                    setSelectedKeys(e.target.value ? [e.target.value] : []);
                }}
                onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    input.focus();
                }}
                onPressEnter={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    confirm();
                }}
                onBlur={confirm}
            />
        </div>
    );
};
Component.displayName = "TableSearchFilterDropdown";
Component.propTypes = {
    setSelectedKeys: PropTypes.func,
    confirm: PropTypes.func,
    clearFilters: PropTypes.func,
    selectedKeys: PropTypes.any,
    filterOverrideClassName: PropTypes.string
};
export default Component;
